import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { RmRackAdapter } from './dto/rm-racks.adapter';
import { RmRacksController } from './rm-racks.controller';
import { RmRack } from './rm-racks.entity';
import {RmRacksService } from './rm-racks.service';

@Module({
  imports: [
    TypeOrmModule.forFeature([RmRack]),
  ],
  controllers: [RmRacksController],
  providers: [RmRacksService,RmRackAdapter,ApplicationExceptionHandler]
})
export class RmRacksModule {}
